import { useContext } from 'react';
import { ModalContext } from '../../contexts/ModalContext';
import { OpenAppQrPanel } from './OpenAppQrPanel';

export function OpenAppQrModal() {
  const { handleModal } = useContext(ModalContext);

  return (
    <div className="soundpill-open-app-qr-modal-host text-left">
      <OpenAppQrPanel onClose={() => handleModal()} variant="modal" showConfirmButton />
    </div>
  );
}
